module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/authentication/logout/logout.component.html
// module id = ./src/app/pages/authentication/logout/logout.component.html
// module chunks = main